/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAIAgentsTraceCollector extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAIAgentsTraceCollector");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAIAgentsTraceCollector.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAIAgentsTraceCollector>): BackgroundJobPayloadForPeriodicAIAgentsTraceCollector {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAIAgentsTraceCollector(), model);
        BackgroundJobPayloadForPeriodicAIAgentsTraceCollector.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAIAgentsTraceCollector>): BackgroundJobPayloadForPeriodicAIAgentsTraceCollector {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAIAgentsTraceCollector.newInstance(<BackgroundJobPayloadForPeriodicAIAgentsTraceCollector> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAIAgentsTraceCollector) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAIAgentsTraceCollector.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAIAgentsTraceCollector): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAIAgentsTraceCollector.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
